<head>
    <!-- Google Tag Manager -->

    <script>(function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f); })(window, document, 'script', 'dataLayer', 'GTM-KB72W5J');</script>

    <!-- End Google Tag Manager -->


</head>
<div class="hero" id="home">
    <div class="shell shell--size-2">
        <nav class="nav hidden visible-xs-block">
            <ul>
                <li>
                    <a [routerLink]="['/home']">Home</a>
                </li>

                <li>
                    <a href="#about">About</a>
                </li>

                <li>
                    <!-- <a onClick="document.location='/#etoroLoc';">eToro</a> -->
                    <a [routerLink]="['/academy']">Academy</a>
                </li>

                <li>
                    <!-- <a onClick="document.location='/#backtesting';">Backtesting</a> -->
                    <a href='/#etoroLoc'>Performance</a>
                </li>

                <li>
                    <a href="#brochure">Brochure</a>
                </li>

            </ul>
        </nav><!-- /.nav -->
        <div class="hero__media">

            <div class="hero__image heroImg"></div><!-- /.hero__image -->

            <!-- <p class="hero__play js-play"  target="_blank">
            <img src="assets/img/svg/ico-play.svg" alt="Play button">
        </p> -->
            <!-- /.hero__media -->


        </div>

        <div class="hero__content" *ngIf="!mobile">

            <div class="row">
                <h1 style="color: #5ECE42;">Creating your eToro account</h1>
            </div>

            <div class="row">
                You're now about to depart Backseat-Trader to establish your
                Copy Trading account on eToro.
            </div>

            <div class="row">
                To assist on this journey here are a couple of short videos
                covering the sign-up process:
            </div>

            <div class="row">
                <div class="col d-flex justify-content-center text-center my-auto">
                    <i class="fa-solid fa-photo-film fa-4x" style="color: #5ECE42;"></i>
                </div>
                <div class="col my-auto">
                    <div class="row">
                        <a href="https://drive.google.com/file/d/12RTEKV5jcDWLh0fRb9H8kh3m1M2UbYTj/view?usp=sharing">Opening
                            your account</a>
                    </div>
                    <div class="row">
                        <a href="https://drive.google.com/file/d/14qbtsbn60B_1lgIIOjqdbqv_UPLO_n9E/view?usp=sharing">Verifying
                            your account</a>
                    </div>
                </div>

            </div>

            <div class="row">
                Once you've signed-up with eToro and have your Username
                you'll then need to return to Backseat-Trader to Register it with
                us, a process which takes less than a minute.
            </div>

            <div class="row">
                For a friendly reminder to return, click this link:
            </div>
            <br />
            <div class="row">
                <div class="col text-center">
                    <a (click)="open(content)"><i class="fa-solid fa-bell fa-4x section__icon etoroBtnHowDesk"
                            style="color: #5ECE42;"></i></a><br />
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col text-center">
                    <a class="btn joinUsBtn" target="_blank" rel="noopener noreferrer" id="intmdJoinUs"
                        (click)="gtag_report_conversion('https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term=')">Join
                        us on eToro</a><br/><br/>
                        <div style="font-size: small;">Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div> 
                </div>
            </div>
        </div><!-- /.hero__content -->
        <div class="hero__content" *ngIf="mobile" style="color: black; font-weight: bold;">
            <div class="row">
                <h1 style="color: #5ECE42;">Creating your eToro account</h1>
            </div>

            <div class="row">
                You're now about to depart Backseat-Trader to establish your
                Copy Trading account on eToro.
            </div>

            <div class="row">
                To assist on this journey here are a couple of short videos
                covering the sign-up process:
            </div>

            <div class="row">
                <div class="col d-flex justify-content-center text-center my-auto">
                    <i class="fa-solid fa-photo-film fa-4x" style="color: #5ECE42;"></i>
                </div>
                <div class="col my-auto">
                    <div class="row">
                        <a href="https://drive.google.com/file/d/12RTEKV5jcDWLh0fRb9H8kh3m1M2UbYTj/view?usp=sharing">Opening
                            your account</a>
                    </div>
                    <div class="row">
                        <a href="https://drive.google.com/file/d/14qbtsbn60B_1lgIIOjqdbqv_UPLO_n9E/view?usp=sharing">Verifying
                            your account</a>
                    </div>
                </div>

            </div>

            <div class="row" style="color: black">
                Once you've signed-up with eToro and have your Username
                you'll then need to return to Backseat-Trader to Register it with
                us, a process which takes less than a minute.
            </div>

            <div class="row" style="color: black">
                For a friendly reminder to return, click this link:
            </div>
            <br />
            <div class="row">
                <div class="col text-center">
                    <a (click)="open(content)"><i class="fa-solid fa-bell fa-4x section__icon etoroBtnHowDesk"
                            style="color: #5ECE42;"></i></a><br />
                </div>
            </div>
            <div class="row">
                <div class="col text-center">
                    <a class="btn joinUsBtn" target="_blank" rel="noopener noreferrer" id="intmdJoinUs"
                        (click)="gtag_report_conversion('https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term=')">Join
                        us on eToro</a><br/><br/>
                        <div style="font-size: small; font-weight: normal;">Copy Trading does not amount to investment advice. Your investments value may go up or down. Your capital is at risk.</div> 
                </div>
            </div>
        </div><!-- /.hero__content -->
    </div><!-- /.shell -->
</div><!-- /.hero -->
<!-- <section class="section-image">
    <div class="shell">
        <div class="section__image imageSection"></div>
       

        <div class="section__content">
            <img src="assets/img/svg/ico-award.svg" alt="Award" loading="lazy"/>


            <h3 class="howItWorks">Why Register With Us

            </h3>

            <ul *ngIf="!mobile">
                <li class="wow fadeInRight" data-wow-delay=".5s">
                    <img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy"/>

                    <h5>More comprehensive reporting and analysis</h5>

                    <p>Conveniently access our report updates which run on a 10-day cycle.</p>
                        
                </li>

                <li class="wow fadeInRight" data-wow-delay="1.5s">
                    <img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

                    <h5>Single click access</h5>

                    <p>Having registered, a single click takes you directly to your own account or that of BackseatTrader.</p>
                       
                </li>

                <li class="wow fadeInRight" data-wow-delay="2.5s">
                    <img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

                    <h5>A rich learning experience</h5>

                    <p>All aspects of the algorithm's behaviour are explained in easy to understand terms with the convenience of audio should the viewer prefer.</p>

                    
                </li>
            </ul>

            <ul *ngIf="mobile">
                <li class="wow fadeInRight" data-wow-delay=".5s">
                    <img src="assets/img/svg/ico-list-1.svg" alt="Item 1" loading="lazy"/>

                    <h5>More comprehensive reporting and analysis</h5>

                    <p>Conveniently access our report updates which run on a 10-day cycle.</p>
                </li>

                <li class="wow fadeInRight" data-wow-delay="1.5s">
                    <img src="assets/img/svg/ico-list-2.svg" alt="Item 2" loading="lazy">

                    <h5>Single click access</h5>

                    <p>Having registered, a single click takes you directly to your own account or that of BackseatTrader.</p>
                </li>

                <li class="wow fadeInRight" data-wow-delay="2.5s">
                    <img src="assets/img/svg/ico-list-3.svg" alt="Item 3" loading="lazy">

                    <h5>A rich learning experience</h5>

                    <p>All aspects of the algorithm's behaviour are explained in easy to understand terms with the convenience of audio should the viewer prefer.</p>
                </li>
            </ul>

            

        </div>
    </div>
</section> -->
<!-- <section class="section-image">
    <div class="shell">
        <div class="section__content">
            <a class="btn joinUsBtn" target="_blank" rel="noopener noreferrer" id="intmdJoinUs" (click)="gtag_report_conversion('https://www.etoro.com/?ref=18514998&compEligible=0&BannerID=4026&utm_medium=Direct&utm_source=11&utm_content=0&utm_serial=ShortURL_WS_CP&utm_campaign=ShortURL_WS_CP&utm_term=')">Join us on eToro</a>
        </div>
    </div>
</section> -->

<ng-template #content let-modal>
    <!-- <div class="modal-header">
    </div> -->
    <div class="centerAlign">
        <div class="modal-body">
            <br />
            <h1>Email Reminder</h1>
            <div>
                <br />
                <span style="font-size: large">By filling out this form, you will receive an email reminder in 10 days
                    to return to Backseat-Trader and complete your registration.</span><br />
                <label class="label1">
                    <span>Email Address:</span><br />
                    <input type="email" name="email" (input)="subscribeEmail=$event.target.value">
                </label>
                <br /><br />
                <div class="failParent" *ngIf="fail">
                    <span class="failNot">
                        {{subText}}
                    </span>
                </div>

                <div class="successParent" *ngIf="show">
                    <span class="successNot">
                        {{subText}}
                    </span>
                </div>
                <!-- <label class="label2">
                    <span>Message</span> <br/>
                    <textarea name="message" rows="6" cols="35"></textarea>
                </label> -->
            </div>
            <br />
            <!-- your other form fields go here -->
            <div class="subOrClose">

                <button type="submit" class="btn sendBtn" (click)="send()">Send</button>

                <!-- <button type="button" class="btn btn-danger closeBtn" style="backgrocolor:red"(click)="modal.close('Close')">Close</button> -->


            </div>
        </div>
        <!-- <div class="modal-footer justCenter">
        </div> -->
    </div>
    <br />
</ng-template>